import React from "react";
import { useEffect } from "react";

const LiveChat = () => {
    if (!global || !global.location || !global.location.hostname) {
        return null;
    }
    const domain = global.location.hostname;

    useEffect(() => {
        const jsContent = `
        var __siteLanguage = document.getElementsByTagName('html')[0].getAttribute('lang');
        if (__siteLanguage === 'fr') {
            var initESW = function(gslbBaseURL) {
            embedded_svc.settings.storageDomain = '${domain}'; 
            embedded_svc.settings.displayHelpButton = true; //Or false
            embedded_svc.settings.language = 'fr'; //For example, enter 'en' or 'en-US'
            embedded_svc.settings.defaultMinimizedText = 'Clavarder avec nous!'; //(Defaults to Chat with an Expert)
            embedded_svc.settings.loadingText = 'Chargement'; //(Defaults to Loading)
            embedded_svc.settings.offlineSupportMinimizedText = 'Clavardage non disponible'; //(Defaults to Contact Us)
            embedded_svc.settings.enabledFeatures = ['LiveAgent'];
            embedded_svc.settings.entryFeature = 'LiveAgent';
            embedded_svc.settings.extraPrechatFormDetails = [{
                "label":"Prénom",  
                "transcriptFields": ["Chat_Visitor_First_Name__c"]
            },{    
                "label":"Nom",         
                "transcriptFields": ["Chat_Visitor_Last_Name__c"]    
            } ,{
            "label":"Adresse courriel",         
            "transcriptFields": ["Chat_Visitor_Email__c"]
                
                }];
                
                    embedded_svc.settings.extraPrechatInfo = [{
                    "entityFieldMaps": [{
                    "doCreate": false,
                    "doFind": true,
                    "fieldName": "FirstName",
                    "isExactMatch": true,
                    "label": "Prénom"
                    }, {
                    
                    "doCreate": false,
                    "doFind": true,
                    "fieldName": "LastName",
                    "isExactMatch": true,
                    "label": "Nom"
                    }, {
                    "doCreate": false,
                    "doFind": true,
                    "fieldName": "Email",
                    "isExactMatch": true,
                    "label": "Adresse courriel"
                    }],
                    "entityName": "Contact"
                }];
        
                embedded_svc.init(
                    'https://spi-secu.my.site.com',
                    'https://spi-secu.my.site.com/OHS', 
                    gslbBaseURL,
                    '00D4P000000hKXU',
                    'Chat_Agents_FR',
                    {
                        baseLiveAgentContentURL: 'https://c.la3-c1-ph2.salesforceliveagent.com/content',
                        deploymentId: '5724P000000Y9XX',
                        buttonId: '5734P000000YAWk',
                        baseLiveAgentURL: 'https://d.la3-c1-ph2.salesforceliveagent.com/chat',
                        eswLiveAgentDevName: 'Chat_Agents_2',
                        isOfflineSupportEnabled: true
                    }
                );
            };
        
            if (!window.embedded_svc) {
                var s = document.createElement('script');
                s.setAttribute('src', 'https://spi-secu.my.salesforce.com/embeddedservice/5.0/esw.min.js');
                s.onload = function() {
                    initESW(null);
                };
                document.body.appendChild(s);
            } else {
                initESW('https://service.force.com');
            }
        } else{
            var initESW = function(gslbBaseURL) {
                embedded_svc.settings.storageDomain = '${domain}'; 
                embedded_svc.settings.displayHelpButton = true; //Or false
                embedded_svc.settings.language = 'en'; //For example, enter 'en' or 'en-US'
                embedded_svc.settings.defaultMinimizedText = 'Chat with us!'; //(Defaults to Chat with an Expert)
                embedded_svc.settings.disabledMinimizedText = 'Chat service unavailable'; //(Defaults to Agent Offline)
                embedded_svc.settings.offlineSupportMinimizedText = 'Chat service unavailable'; //(Defaults to Contact Us)
                embedded_svc.settings.enabledFeatures = ['LiveAgent'];
                embedded_svc.settings.entryFeature = 'LiveAgent';    
                embedded_svc.settings.extraPrechatFormDetails = [{
        
                          "label":"First Name",  
                          "transcriptFields": ["Chat_Visitor_First_Name__c"]
        
                },{
                
                         "label":"Last Name",         
                         "transcriptFields": ["Chat_Visitor_Last_Name__c"]
                
                } ,{
                
                         "label":"Email",         
                         "transcriptFields": ["Chat_Visitor_Email__c"]
                
                }];
                
                embedded_svc.settings.extraPrechatInfo = [{
                      "entityFieldMaps": [{
                "doCreate": false,
                "doFind": true,
                "fieldName": "FirstName",
                "isExactMatch": true,
                "label": "First Name"
                }, {
                   
                "doCreate": false,
                "doFind": true,
                "fieldName": "LastName",
                "isExactMatch": true,
                "label": "Last Name"
                }, {
                "doCreate": false,
                "doFind": true,
                "fieldName": "Email",
                "isExactMatch": true,
                "label": "Email"
                }],
                "entityName": "Contact"
                }];
        
                embedded_svc.init(
                    'https://spi-secu.my.site.com',
                    'https://spi-secu.my.site.com/OHS',
                    gslbBaseURL,
                    '00D4P000000hKXU',
                    'Chat_Agents_EN',
                    {
                        baseLiveAgentContentURL: 'https://c.la3-c1-ph2.salesforceliveagent.com/content',
                        deploymentId: '5724P000000Y9XX',
                        buttonId: '5734P000000YAWf',
                        baseLiveAgentURL: 'https://d.la3-c1-ph2.salesforceliveagent.com/chat',
                        eswLiveAgentDevName: 'Chat_Agents',
                        isOfflineSupportEnabled: true
                    }
                );
            };
        
            if (!window.embedded_svc) {
                var s = document.createElement('script');
                s.setAttribute('src', 'https://spi-secu.my.salesforce.com/embeddedservice/5.0/esw.min.js');
                s.onload = function() {
                    initESW(null);
                };
                document.body.appendChild(s);
            } else {
                initESW('https://service.force.com');
            }
        }
        `;
        const script = document.createElement("script");
        script.innerHTML = jsContent;
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, [domain]);

    return null;
};

export default LiveChat;
